import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { apiAction, generalSet } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';
import EditVariables from './EditVariables';
import ManageFilters from './ManageFilters';
import ManageCheckers from './ManageCheckers';

const SubCondition = () => {
  const dispatch = useDispatch();
  const { condition_id, sub_condition_id } = useParams();

  const { condition } = useSelector((state) => state.general);
  console.log({ condition });
  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'condition',
        route: `conditions/getConditionById`,
        conditionId: condition_id,
      })
    );
  }, []);
  if (condition?._id !== condition_id) {
    dispatch(
      generalSet({
        reduxField: 'condition',
        value: null,
      })
    );
  }
  if (!condition?._id || !Array.isArray(condition?.subConditions) || !condition?.subConditions.length) {
    return <Spinner />;
  }
  const subCondition = condition.subConditions.filter((sCon) => sCon._id === sub_condition_id)[0];
  console.log({ subCondition });
  if (!subCondition?._id) {
    return (
      <div>
        <h4>No Condition Found</h4>
      </div>
    );
  }

  return (
    <div data-aos='fade-up' data-aos-delay='200'>
      <div className='row justify-content-left align-items-center mt-2'>
        <div className='col-md-12'>
          <Link className='btn btn-sm btn-outline-dark border-0' to={`/condition/${condition._id}`}>
            Back to Condition Details
          </Link>
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <div
          className='col-lg-12 d-flex justify-content-center mt-2 pt-lg-0 border-bottom'
          data-aos='fade-up'
          data-aos-delay='200'
        >
          <h1>Edit Sub Condition</h1>
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <h5>
          <Link className='text-primary' to={`/condition/${condition._id}`}>
            {condition.name}
          </Link>
        </h5>
      </div>{' '}
      <div className='row d-flex justify-content-center pt-lg-0'>
        <small>
          <b>Sub Condition: </b> <span className='text-primary'>{subCondition.name}</span>
        </small>
      </div>{' '}
      <EditVariables condition={condition} subCondition={subCondition} />
      <div className='border-top'></div>
      <ManageCheckers condition={condition} subCondition={subCondition} />
    </div>
  );
};

export default SubCondition;
